export default __webpack_public_path__ + "static/media/doisACincoAnos.9347383f.svg";